export default __webpack_public_path__ + "static/media/dice game.dc0e567b.png";